<template>
  <div class="basic_picture_text_swiper">
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="list_frame">
      <template v-if="Number(listArr.module_style)===0">
        <group_style_1
          :pc_infor="pc_infor"
          :infor="infor"
          :imgs="imgs"
          :module="module"
        ></group_style_1>
      </template>
      <template v-else>
        <group_style_2
          :pc_infor="pc_infor"
          :infor="infor"
          :imgs="imgs"
          :module="module"
        ></group_style_2>
      </template>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import one_icon from "./components/one_picture";
import group_style_1 from "./components/group_style_1";
import group_style_2 from "./components/group_style_2";
import {getSwiperSettingData} from "@/base/widgets_data_compatible";

export default {
  name: "basic_picture_text_swiper",
  components: {
    one_icon,
    group_style_1,
    group_style_2,
  },
  data() {
    return {
      imgs: [],
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + "_widgets_infor"];
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr
    },
  },
  watch: {
    "module.data.listArr": {
      handler: function (val, oldVal) {
        this.templet.icons_init(this)
      },
      deep: true
    },
  },
  methods: {},
  created() {
    this.templet.icons_init(this);
    if (!this.pc_infor.banner_set) {
      this.$set(this.pc_infor, "banner_set", getSwiperSettingData().banner_set);
    }    
  },
  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style scoped lang="scss">
.basic_picture_text_swiper {
  .list_frame {
    width: 100%;

    .list_box {
      display: flex;
      flex-flow: wrap;
      font-size: 0;
      position: relative;
    }

  }
}

.pc_pattern {
  .list_frame {
    min-height: 50px;
  }
}

.mb_pattern {
  .list_one {
    padding: 1.89% !important;
  }

  .list_box {
    padding: 1.89% !important;
  }

  .list_frame {
    overflow: hidden;
  }
}
</style>

<style lang="scss">
// 移动端
.mb_pattern {

  .basic_picture_text_swiper {
    .style-wrapper-1 {
      .btn-pagination {
        display: none;
      }

      .style-wrapper {
        padding: 1.89%;
      }

      .list_box {
        padding: 1.89%;
      }

      .listBoxWrapper.list_box.list-box-0 {
        width: 100%;
      }
    }


    .style-wrapper.style-wrapper-2 {

      .list_frame {
        .list_box.listBoxWrapper {
          width: 100%;
          height: auto;
        }
      }

      .bt-group {
        display: none;
      }

      .btn-pagination {
        display: none;
      }

      .list_box {
        height: auto;
      }

      .swiper-container {
        height: auto;
      }

      .swiper-wrapper {
        display: flex;
        height: auto;
      }

      .swiper-slide {
        height: auto;
      }

      .icon-combination-summary {
        overflow: visible;
        display: inline-block;
      }

      .listBoxWrapper {
        padding: 1.89%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_picture_text_swiper/index.vue